import {createStore, applyMiddleware} from "redux";
import createSagaMiddleware from "redux-saga";
import reducer from "./reducers";
import * as Sagas from "./sagas";

const sagaMiddleware = createSagaMiddleware();

const store = createStore(reducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(Sagas.loadShopSaga);
sagaMiddleware.run(Sagas.loadShopGroupSaga);

export default store;
